import script from "./SBU.vue?vue&type=script&setup=true&lang=js"
export * from "./SBU.vue?vue&type=script&setup=true&lang=js"

import "./SBU.vue?vue&type=style&index=0&id=25dad3cf&lang=css"

const __exports__ = script;

export default __exports__